import {
  getPresentDraw,
  getSyntheticDraw,
  getActivityLottery,
} from "@/api/active";

const state = {
  drawList: {},
  activityLotteryList: {},
  activityLotteryId: "",
};

// getters
const getters = {
  drawList: (state) => state.drawList,
  activityLotteryList: (state) => state.activityLotteryList,
  activityLotteryId: (state) => state.activityLotteryId,
};

// actions
const actions = {
  getPresentDraw(context, data) {
    return getPresentDraw(data).then(res => {
      context.commit("setDrawList", res.data);
    });
  },
  // getSyntheticDraw(context, data) {
  //   return getSyntheticDraw(data).then(res => {
  //     context.commit("setDrawList", res.data);
  //   });
  // },
  async getActivityLottery(context, data) {
    const res = await getActivityLottery(data);
    if (res.resultID == 1200) {
      context.commit("setActivityLotteryList", res.data);
      context.commit("setActivityLotteryId", res.data.id);
    };
  },
};

// mutations
const mutations = {
  setDrawList(state, data) {
    state.drawList = data;
  },
  setActivityLotteryList(state, data) {
    state.activityLotteryList = data;
  },
  setActivityLotteryId(state, data) {
    state.activityLotteryId = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
